export default {};
throw new Error(`Could not resolve "@walletconnect/ethereum-provider" imported by "@wagmi/connectors". Is it installed?`)